/* Cloudinary video — source selection for the PDP gallery and the footer marquee */
(function () {
  // Chrome skips `video/quicktime; codecs=hvc1...` but Firefox accepts it, decodes the
  // HEVC and drops the alpha, so a <source> type no longer isolates Safari. WebKit is
  // the only engine that composites HEVC alpha and the only one that ignores WebM
  // alpha, so select on the engine. On iOS every browser is WebKit and needs the HEVC.
  if ("GestureEvent" in window) return;

  function prune(root) {
    if (!root.querySelector('source[type*="webm"]')) return 0;
    var hevc = root.querySelectorAll('source[type*="quicktime"]');
    for (var i = 0; i < hevc.length; i++) hevc[i].remove();
    return hevc.length;
  }

  // Both hosts are listed here rather than each shipping its own copy of the engine
  // test. The marquee loads this script too, and running it twice on a PDP is
  // harmless — removing an already-removed source is a no-op.
  var slides = document.querySelectorAll(
    ".media-gallery__cloudinary-video, .footer-marquee__overlay--cloudinary, .image-block__cloudinary"
  );
  for (var i = 0; i < slides.length; i++) {
    var template = slides[i].querySelector("template");
    if (template) prune(template.content);
    // Only matches if this ran late; the <video> normally still sits in the template.
    var video = slides[i].querySelector("video");
    if (video && prune(video)) video.load();
  }
})();
